import React from 'react';

const CountryTracks = () => {
    return (
<div className='w-full h-screen flex items-center justify-center flex-col gap-3'>
    <img  src='/img/coming-son.svg' className='w-[200px]' />
     <p className='text-gray-300 font-semibold text-lg capitalize'>our team is at hard work to ring this feature</p>
</div>

)

}
export default CountryTracks;
